import Title from "~/components/product/ProductDescription/Title"

interface Props {
    description?: string
}

export default function Description({ description }: Props) {
    return (
        <>
            <Title>DESCRIÇÃO</Title>
            {description && (
                <div
                    className='text-black [&_a]:text-pink'
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            )}
        </>
    )
}
